import { render, staticRenderFns } from "./pbrConfirmIndex.vue?vue&type=template&id=2b50d28c&"
import script from "./pbrConfirmIndex.vue?vue&type=script&lang=js&"
export * from "./pbrConfirmIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports